export function formatPickupCurrency(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(Number(value))) {
    return '—';
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(Number(value));
}

export function formatPickupPrice(value: number | null | undefined): string {
  return value === null || value === undefined || !Number.isFinite(Number(value))
    ? '—'
    : Number(value).toFixed(3);
}

export function formatPickupPoints(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(Number(value))) {
    return '—';
  }
  const numberValue = Number(value);
  return `${numberValue > 0 ? '+' : ''}${numberValue.toFixed(3)}`;
}

export function formatPickupDate(value: string | null | undefined): string {
  if (!value) {
    return '—';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: date.getFullYear() === new Date().getFullYear() ? undefined : 'numeric'
  }).format(date);
}

export function formatPickupDateTime(value: string | null | undefined): string {
  if (!value) {
    return '—';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  }).format(date);
}

export function formatPickupExpiryShort(
  value: string | null | undefined,
  nowMs = Date.now()
): string {
  if (!value) {
    return '—';
  }
  const expiration = new Date(value);
  if (Number.isNaN(expiration.getTime())) {
    return '—';
  }
  const now = new Date(nowMs);
  const expirationDay = Date.UTC(
    expiration.getFullYear(),
    expiration.getMonth(),
    expiration.getDate()
  );
  const currentDay = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  const days = Math.ceil((expirationDay - currentDay) / (24 * 60 * 60 * 1000));
  if (days < 0) {
    return `${Math.abs(days)}d past`;
  }
  return `${days}d`;
}

export function formatPickupAge(value: string | null | undefined, nowMs = Date.now()): string {
  if (!value) {
    return '—';
  }
  const time = Date.parse(value);
  if (!Number.isFinite(time)) {
    return '—';
  }
  const hours = Math.max(0, Math.floor((nowMs - time) / (60 * 60 * 1000)));
  if (hours < 24) {
    return `${hours}h`;
  }
  return `${Math.floor(hours / 24)}d`;
}

export function toDateTimeLocal(value?: string | null): string {
  const date = value ? new Date(value) : new Date();
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  const offset = date.getTimezoneOffset() * 60 * 1000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
}

export function dateTimeLocalToIso(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    throw new Error('Enter a valid date and time.');
  }
  return date.toISOString();
}
